import React from 'react';
import Table from './Table';
import BarAndLineCharts from './BarAndLineChart';
import PieCharts from './PieCharts';

export default function Chart(props: any) {
  if (props.type === 'table')
    return (
      <Table
        {...props}
        records={props.data.tableRecord}
      />
    );
  if (props.type === 'pie') return <PieCharts {...props} />;
  return <BarAndLineCharts {...props}></BarAndLineCharts>;
}